
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-view-single-tag-selector-v1',
    templateUrl: './view-single-tag-selector-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewSingleTagSelectorV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;

    ngOnInit(): void {

    }


}
